import { Helmet } from 'react-helmet';
import Lines from '../../components/light/common/Lines';
import ProgressScroll from '../../components/light/common/ProgressScroll';
import Cursor from '../../components/light/common/cusor';
import LoadingScreen from '../../components/light/common/loader';
// import Blog from '../../components/light/creative-agency/Blog';
import Brands from '../../components/light/creative-agency/Brands';
import Footer from '../../components/light/creative-agency/Footer';
import Header from '../../components/light/creative-agency/Header';
import ImageScale from '../../components/light/creative-agency/ImageScale';
import Marquee from '../../components/light/creative-agency/Marquee';
import Navbar from '../../components/light/creative-agency/Navbar';
import Numbers from '../../components/light/creative-agency/Numbers';
import Portfolio from '../../components/light/creative-agency/Portfolio';
import Services from '../../components/light/creative-agency/Services';
import Skills from '../../components/light/creative-agency/Skills';
import Testimonials from '../../components/light/creative-agency/Testimonials';
import AiSectionGallery from '../../components/light/ai/AiSectionGallery';
import '../../components/light/ai/aiStyles.css';


export default function LHomeCreativeAgency() {
  return (
    <>
      <Helmet>
        <title>Aashway - Branding Agency, Digital Marketing & Web Development Experts</title>
        <link rel="icon" href="/light/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/light/imgs/favicon.ico" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/satoshi.css"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght..200;300;400;500;600;700&display=swap"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />

        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg pt-80 o-hidden">
              <Header />
              <Marquee />
              <Services />
              <Portfolio />
              
              <section className="ai-section-wrap">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <div className="section-head">
                        <h2 className="text-u">AI</h2>
                        <p className="fz-16 mt-2">A curated preview of Videos, Model Shoot & Product Shoot.</p>
                      </div>
                    </div>

                    <div className="col-12 mt-30">
                      <AiSectionGallery
                        videos={[
                          { fileName: 'drinks.mp4', src: '/light/assets/ai/Videos/drinks.mp4' },
                          { fileName: 'clothing.mp4', src: '/light/assets/ai/Videos/clothing.mp4' },
                        ]}
                        images={[
                          { fileName: '1.jpg', src: '/light/assets/ai/Model Shoot/1.jpg' },
                          { fileName: '2.jpg', src: '/light/assets/ai/Model Shoot/2.jpg' },
                          { fileName: '3.jpg', src: '/light/assets/ai/Product Shoot/3.jpg' },
                          { fileName: '6.jpg', src: '/light/assets/ai/Product Shoot/6.jpg' },
                        ]}
                      />
                    </div>

                    <div className="col-12 mt-30 text-center">
                      <a href="/light/page-ai" className="ai-explore-link">Explore</a>
                    </div>
                  </div>
                </div>
              </section>
              
              <Skills />
              <Numbers />
              <Testimonials />
              <Brands />
              <ImageScale />

              {/* <Blog /> */}
            </main>

            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}

